import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'redux-form'
import styles from './_textField.css'
import classnames from 'classnames'
import fieldProps from '../fieldProps'
import FieldLabel from '../FieldLabel'
import FieldError from '../FieldError'

export const TextField = (props) => {
  const {
    bold,
    input,
    required,
    name,
    labelComponent,
    errorComponent,
    slim,
    disabled,
    rows,
    meta: {
      touched,
      error,
    },
  } = props

  const showError = Boolean(touched && error)
  const className = classnames(styles.container, {
    [styles.disabled]: disabled,
    [styles.slim]: slim,
  })

  return (
    <label htmlFor={name} className={className}>
      <FieldLabel
        bold={bold}
        labelComponent={labelComponent}
        required={required}
        disabled={disabled}
      />
      <div className={styles.inputContainer}>
        <textarea
          {...input}
          rows={rows}
          disabled={disabled}
          className={classnames(styles.input, { [styles.error]: showError })}
        />
      </div>
      <FieldError
        errorComponent={errorComponent}
        showError={showError}
        errorMessage={error}
      />
    </label>
  )
}

TextField.propTypes = fieldProps
TextField.defaultProps = {
  rows: 3,
}

export const renderField = (field) => <TextField {...field} />
export const FieldWrapper = (props) => <Field {...props} component={renderField} />

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/forms/TextField/TextField.jsx